import { create } from 'zustand';

export const useShareImgModalStore = create((setState, getState) => {
  return {
    /* state */
    open: false,
    imgInfo: null,
    modelUuid: '',
    batchType: null,
    onFinish: null,
    defaultModel: [],
    /* actions */
    showShareImgModal(params) {
      console.log('showShareImgModal', params);
      setState({
        // default values
        imgInfo: null,
        modelUuid: '',
        batchType: null,
        onFinish: null,
        //
        ...params,
        open: true,
      });
    },
    hideShareImgModal(runOnFinish, isSuccess) {
      const { onFinish } = getState();

      setState({
        open: false,
        imgInfo: null,
        modelUuid: '',
        batchType: null,
        onFinish: null,
        defaultModel: [],
      });
      if (runOnFinish && onFinish) {
        onFinish(isSuccess);
      }
    },
  };
});
